const state = () => ({
  license: {},
});

const actions = {};

const mutations = {
  setCurrentLicense(state, license) {
    state.license = license;
  },
};

const getters = {
  license: (state) => state.license,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
